export default "/images/location-closed.svg?84065a39739a6e6d18a22935dfd84d55";